import React from "react"

const BurgerSvg = ({ className, full }) => {
  return (
    <svg className={className} width="28px" height="28px" viewBox="0 0 28 28">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect id="outline" fillRule="nonzero" x="0" y="0" width="28" height="28"></rect>
        <g transform="translate(4.000000, 8.000000)" fill={full ? full : "#323237"} fillRule="nonzero">
          <path d="M0,13.3333333 L20,13.3333333 L20,11.1111111 L0,11.1111111 L0,13.3333333 Z M0,7.77777778 L20,7.77777778 L20,5.55555556 L0,5.55555556 L0,7.77777778 Z M0,0 L0,2.22222222 L20,2.22222222 L20,0 L0,0 Z"></path>
        </g>
      </g>
    </svg>
  )
}

export default BurgerSvg
